/*
  Pure JS Tabs
  reference: https://codepen.io/codeorum/pen/ExPMooBx
*/

function initTab(elem){
          document.addEventListener('click', function (e) {
              if (!e.target.matches(elem+' .t-btn')) return;
              else{
                  if(!e.target.classList.contains('active')){
                      findActiveElementAndRemoveIt(elem+' .t-btn');
                      findActiveElementAndRemoveIt(elem+' .t-panel');
                      e.target.classList.add('active');  
                      setTimeout(function(){                 
                          var panel = document.querySelectorAll(elem+' .t-panel.'+e.target.dataset.name);
                          Array.prototype.forEach.call(panel, function (el) {
                              el.classList.add('active');
                          });
                      }, 200);
                  }
              }
          });
      }

      function findActiveElementAndRemoveIt(elem){
          var elementList = document.querySelectorAll(elem);
          Array.prototype.forEach.call(elementList, function (e) {
              e.classList.remove('active');
          });
      }
      initTab('.tabs.morning');
      initTab('.tabs.evening');
